export default __webpack_public_path__ + "static/media/element_21.028dbae7.avif";